import { locale } from '@trqk/utils';

export const periodOptions: DropdownOption<{ period: number }>[] = [
    {
        label: locale.enUS.ACCOUNT.SECTIONS.NOTIFICATIONS.DETECTIONS
            .PERIOD_LABELS.DAILY,
        value: {
            period: 24,
        },
    },
    {
        label: locale.enUS.ACCOUNT.SECTIONS.NOTIFICATIONS.DETECTIONS
            .PERIOD_LABELS.WEEKLY,
        value: {
            period: 24 * 7,
        },
    },
];
